export * from './domtools.colors.js';

import * as elementBasic from './domtools.elementbasic.js';
import * as breakpoints from './domtools.css.breakpoints.js';
import * as css from './domtools.css.js';

export { css, breakpoints, elementBasic };
export { DomTools, type IDomToolsContructorOptions } from './domtools.classes.domtools.js';
export { TypedRequest } from '@api.global/typedrequest';
export { type IWebSetupConstructorOptions } from '@push.rocks/websetup';

import * as plugins from './domtools.pluginexports.js';
export { plugins };

// type exports
import type { rxjs } from '@push.rocks/smartrx';

export type {
  rxjs,
}
